export default {
  subtotal: 'Subtotal',
  tip: 'Drikkepenge',
  discount: 'Rabat',
  method_fee: 'Leveringsgebyr',
  service_fee: {
    title: 'Servicegebyr',
    description:
      'Dette lille servicegebyr hjælper os med at dække omkostninger ved hver ordre — som at sende dig sms-opdateringer om din ordre, drive vores onlinebestillingsplatform og håndtere ekstra transaktionsrelaterede gebyrer. Og bare rolig — gebyret er stadig langt lavere, end hvad du ville betale hos leveringsapps. Tak for din forståelse og for at støtte os direkte. Vi sætter pris på dig!',
  },
  payment_method_upcharge_fee: {
    title: 'PayPal-gebyr',
    description:
      'Hver gang en kunde betaler med PayPal, opkræver PayPal 6-7 % i gebyrer. Så af 100 € mister vi 6-7 €. Derfor er vi desværre nødt til at lægge et tillæg på 3,5 % på for brug af PayPal. 🤯 Overvej at bruge en af de andre sikre og krypterede betalingsmetoder ved checkout. Vi er meget taknemmelige for din forståelse og støtte! 🙏',
  },
  tax: 'Moms',
  total: 'I alt',
  earned_points: 'Du har optjent {{points}} point',
};
